import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { Button } from 'reactstrap'
import Dialog from 'apa/containers/Dialog'
import * as checkpoints from 'catalog/actions/checkpoints'

@connect(
    null,
    dispatch => ({
        remove: checkpoint => dispatch(checkpoints.removeCheckpoint(checkpoint))
    })
)
export default class DeleteCheckpoint extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({ isOpen })
    }

    @autobind
    confirm() {
        this.props.remove(this.props.checkpoint);
        this.toggle();
    }

    render() {
        return (
            <Fragment>
                <Button color='danger' title="Checkpoint löschen" onClick={this.toggle}>
                    <i className='fa fa-trash'> </i>
                </Button>
                <Dialog isOpen={this.state.isOpen} toggle={this.toggle}
                    confirm={this.confirm}
                    title="Checkpoint löschen">
                    Sind Sie sicher, dass Sie den Checkpoint löschen möchten?
            </Dialog>
            </Fragment>
        )
    }
}